import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Container, Typography, Box } from "@mui/material";
import "../css/normalize.css";
import "../css/global.css";
import useSharedLink from "../SharedLink";
import signinImage from "../assets/img/3.jpg";
import { xorDecrypt, xorEncrypt } from "../encrypt";
import axiosInstance from "../api/axiosInstance";

function Success() {
  const [session, setSession] = useState(null);
  const [sessionId, setSessionId] = useState("");
  const sharedLink = useSharedLink();
  // const TestID = "cs_test_a1iCiTZ32GWblehUiLmFVEOgXokvhTWzZK38w39UolGcWGB4FTf7Ky8j45";

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    // const ss = TestID;
    const ss = urlParams.get("session_id");
    //console.log(ss, "SESSIONID");
    document.body.style.backgroundImage = `url(${signinImage})`;
    document.body.style.backgroundSize = "cover";

    if (ss) {
      setSessionId(ss);

      axiosInstance
        .get(`${sharedLink}/checkout-session?sessionId=${ss}`, {
          withCredentials: true,
        })
        .then((response) => {
          setSession(response.data);
          //console.log("SESSION", response);

          const username = xorDecrypt(localStorage.getItem("username"));
          const transactionStored = localStorage.getItem("transactionStored");

          if (ss && username && transactionStored !== "true") {
            // axios
            //   .post(`http://localhost:8080/customer-portal-store`, null, {
            //     params: {
            //       sessionId: ss,
            //       email: username,
            //     },
            //   })
            //   .then((response) => {
            //     //console.log("Transaction stored:", response.data);
            //     localStorage.setItem("transactionStored", "true");
            //   })
            //   .catch((error) => {
            //     console.error("Error storing transaction:", error);
            //   });
          }
          if (response.data.status === "complete") {
            localStorage.setItem("enrollmentStatus", xorEncrypt("true"));
            //console.log("Enrollment status set to true");
          }
        })
        .catch((error) => {
          console.error("Fetch error: ", error);
        });
    }
    return () => {
      document.body.style.backgroundImage = "";
      document.body.style.backgroundSize = "";
    };
  }, []);

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column", // Changed to column for vertical alignment
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Box className="togethere-background" p={3} borderRadius={1}>
        <Box className="sr-root">
          <Box
            className="sr-main"
            mb={4}
            sx={{
              display: "flex",
              flexDirection: "column", // Changed to column for vertical alignment
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "50vw",
              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "4px",
              boxShadow:
                "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)", // Added box shadow
              backdropFilter: "blur(10px)",
            }}
          >
            <Box
              className="sr-payment-summary completed-view"
              textAlign="center"
            >
              <Typography variant="h4" gutterBottom>
                Your payment succeeded
              </Typography>
            </Box>
            <Box
              className="completed-view-section"
              mt={2}
              sx={{
                display: "flex",
                flexDirection: "column", // Changed to column for vertical alignment
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <pre>{session && JSON.stringify(session, null, 2)}</pre> */}
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#e9a132",
                  "&:hover": { backgroundColor: "#ffdb58" },
                }} // Mustard yellow color
                onClick={() => {
                  localStorage.removeItem("transactionStored");
                  window.location.href = "/dashtemp";
                }}
              >
                Dashboard
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default Success;
